import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Axios from "axios";
import * as actionTypes from "./../../../store/actions";
import UniqueTable from "./UniqueTable"
import {
  Row,
  Col,
  Card,
  Button,
  Form,
} from "react-bootstrap";

class UniqueNodeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        // Set initial files, type 'local' means this is a file
        // that has already been uploaded to the server (see docs)
        node: null,
      };

    //   this.handleChangeSelectedEntity = this.handleChangeSelectedEntity.bind(this);
  }


  componentDidMount = function() {

    console.log("Mounted");
    console.log(this.props.selected_node);

   
  };
 
  render() {
    return (
        <div className="modal-body">
      <div className="text-left">
        {/* <h6 className="heading mt-1">Select Node Configs</h6> */}
        <Form>
        <Row>
            <Col md={12}>
                <UniqueTable dtypes_={this.props.selected_node} model={this.props.model} />
             
            </Col>
           
          </Row>
        </Form>
         <p>
         {/* {node.properties.headers.join(',')} */}
        </p>
       <p>
       {/* <span id="coderea">{ JSON.stringify(this.props.node) }</span> */}
       </p>
        
      </div>
    </div>
      );
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UniqueNodeComponent)
);

